var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoClaro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.85 36.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed008e;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2,.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo claro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.45,11.1a18.12,18.12,0,0,0-9.54-9.67A17.78,17.78,0,0,0,5.26,5.31,18,18,0,0,0,1.41,11.1a18.41,18.41,0,0,0,0,14.12A18,18,0,0,0,5.26,31,17.72,17.72,0,0,0,11,34.89a17.83,17.83,0,0,0,14,0,18.12,18.12,0,0,0,9.54-9.67,18.41,18.41,0,0,0,0-14.12m-8.84,4.78a2.94,2.94,0,0,1,2.15.89,3,3,0,0,1,.88,2.16,3,3,0,0,1-3,3.05,3.07,3.07,0,0,1-3-3.05,3,3,0,0,1,.89-2.16,2.86,2.86,0,0,1,2.12-.89M3.89,15.49a3.43,3.43,0,0,1,2.64-1.1,3.49,3.49,0,0,1,2.27.78,3.73,3.73,0,0,1,1.31,2H8.59a2.51,2.51,0,0,0-.82-1,2.27,2.27,0,0,0-2.87.31,2.36,2.36,0,0,0,0,3.29,2.23,2.23,0,0,0,1.63.68,2.34,2.34,0,0,0,1.24-.36,2.61,2.61,0,0,0,.82-1h1.52a3.79,3.79,0,0,1-1.31,2,3.64,3.64,0,0,1-2.27.77,3.57,3.57,0,0,1-2.64-1.09,3.66,3.66,0,0,1-1.1-2.68,3.61,3.61,0,0,1,1.1-2.66m9.79,1.14a2.38,2.38,0,0,1,2-.77,3.37,3.37,0,0,1,1.69.38,1.49,1.49,0,0,1,.72,1.44v4.27H16.69v-.6a2.83,2.83,0,0,1-1.87.6,1.86,1.86,0,0,1-1.18-.4,1.55,1.55,0,0,1-.49-1.24,1.64,1.64,0,0,1,.79-1.58,3.51,3.51,0,0,1,1.25-.38l1.12-.18a.48.48,0,0,0,.33-.45.52.52,0,0,0-.25-.49,1.3,1.3,0,0,0-.71-.14.87.87,0,0,0-.77.28.93.93,0,0,0-.21.53H13.26a2.29,2.29,0,0,1,.42-1.27m-2.83-2.24h1.45v7.56H10.85Zm9.65,2.51a2.31,2.31,0,0,1,1-.82l.56-.15.38,0v1.48l-.45,0a1.41,1.41,0,0,0-.79.25,1.37,1.37,0,0,0-.5.56,2.07,2.07,0,0,0-.18,1v2.77H19.11v-5.8h1.38ZM32.38,12.6l-3.5,3.5L28,15.18l3.5-3.5Zm-6,2.1h-1.3V11h1.3Zm3.1,2.84h3.83v1.3H29.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.76,16.77a2.94,2.94,0,0,0-2.15-.89,2.85,2.85,0,0,0-2.12.89,2.94,2.94,0,0,0-.89,2.16,3.07,3.07,0,0,0,3,3.05,3,3,0,0,0,3-3.05,3,3,0,0,0-.88-2.16m-1,3.29a1.56,1.56,0,0,1-2.24,0A1.59,1.59,0,0,1,24,18.93a1.55,1.55,0,0,1,.47-1.14,1.42,1.42,0,0,1,1.11-.46,1.48,1.48,0,0,1,1.14.46,1.62,1.62,0,0,1,0,2.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.61,20.53a1.49,1.49,0,0,0,1.13-.47,1.65,1.65,0,0,0,.47-1.13,1.61,1.61,0,0,0-.47-1.14,1.6,1.6,0,0,0-2.24,0A1.55,1.55,0,0,0,24,18.93a1.59,1.59,0,0,0,.47,1.13,1.48,1.48,0,0,0,1.12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.52,14.39a3.43,3.43,0,0,0-2.64,1.1,3.61,3.61,0,0,0-1.1,2.66,3.66,3.66,0,0,0,1.1,2.68,3.57,3.57,0,0,0,2.64,1.09,3.64,3.64,0,0,0,2.27-.77,3.78,3.78,0,0,0,1.31-2H8.59a2.61,2.61,0,0,1-.82,1,2.34,2.34,0,0,1-1.24.36,2.23,2.23,0,0,1-1.63-.68,2.36,2.36,0,0,1,0-3.29,2.27,2.27,0,0,1,2.87-.31,2.51,2.51,0,0,1,.82,1h1.52a3.73,3.73,0,0,0-1.31-2,3.49,3.49,0,0,0-2.27-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.72,15.86a2.38,2.38,0,0,0-2,.77,2.29,2.29,0,0,0-.42,1.27h1.45a.93.93,0,0,1,.21-.53.87.87,0,0,1,.77-.28,1.3,1.3,0,0,1,.71.14.52.52,0,0,1,.25.49.48.48,0,0,1-.34.45l-1.11.18a3.53,3.53,0,0,0-1.25.38,1.64,1.64,0,0,0-.79,1.58,1.55,1.55,0,0,0,.49,1.24,1.86,1.86,0,0,0,1.18.4,2.83,2.83,0,0,0,1.87-.6v.6h1.45V17.68a1.49,1.49,0,0,0-.72-1.44,3.38,3.38,0,0,0-1.69-.38m.61,3.28.28-.15v.58a1.22,1.22,0,0,1-.4,1,1.53,1.53,0,0,1-.91.29.79.79,0,0,1-.51-.17.71.71,0,0,1-.21-.57.72.72,0,0,1,.35-.66,1.93,1.93,0,0,1,.68-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.62,19l-.28.15-.72.18a1.91,1.91,0,0,0-.68.2.83.83,0,0,0-.14,1.23.79.79,0,0,0,.52.17,1.53,1.53,0,0,0,.91-.29,1.22,1.22,0,0,0,.4-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.85,
    y: 14.39,
    width: 1.45,
    height: 7.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.52,16.07a2.3,2.3,0,0,0-1,.82v-.74H19.11v5.8h1.44V19.17a2.07,2.07,0,0,1,.18-1,1.37,1.37,0,0,1,.5-.56,1.41,1.41,0,0,1,.8-.25l.45,0V15.89l-.38,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.7,
    y: 13.24,
    width: 4.95,
    height: 1.3,
    transform: "translate(-0.99 25.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.13,
    y: 10.96,
    width: 1.3,
    height: 3.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.53,
    y: 17.55,
    width: 3.83,
    height: 1.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClaro);
export default __webpack_public_path__ + "static/media/logo-claro.e8dcf6bfcc9f2ec3c352637e53dfcae3.svg";
export { ForwardRef as ReactComponent };